<style lang="less" scoped>
/deep/ .el-tabs__item.is-top {width: 150px;text-align: center;padding-left: 20px;}
</style>

<template>
  <el-tabs v-model="editableTabsValue" type="card" @tab-remove='removeTab' :before-leave='Tabever'>
    <el-tab-pane :key="item.name" v-for="(item) in editableTabs" :label="item.title" :name="item.name" :closable="item.closable">
      <component :is="item.content" @addTab="addTab()" @addTab2="addTab2()" @addTab3="addTab3()" @addTab4="addTab4()" @removeTab="removeTab(item.name)" :minor='66'></component>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
/**
 * 李旭
 * 首页数据管理页面
 */
import {mapState} from 'vuex'
import FirInfoLB from '../assembly/FirInfoLB.vue'
import FirRollLB from '../assembly/FirRollLB.vue'
import FirBannerImg from '../assembly/FirBannerImg.vue'
import FirVideoLB from '../assembly/FirVideoLB.vue'
import FirBannerLB from '../assembly/FirBannerLB.vue'
import FirPhotoLB from '../assembly/FirPhotoLB.vue'
import ScienceDataLB from '../assembly/ScienceDataLB.vue'
import FirBannerAdd from '../../../../static/form/FirBannerAdd.vue'
import FirScienceAdd from '../../../../static/form/FirScienceAdd.vue'
import FirPhotoAdd from '../../../../static/form/FirPhotoAdd.vue'
import FirRollAdd from '../../../../static/form/FirRollAdd.vue'
import FirBannerImgAdd from '../../../../static/form/FirBannerImgAdd.vue'


export default {
  components: {
    FirInfoLB,
    FirVideoLB,
    FirBannerLB,
    FirPhotoLB,
    ScienceDataLB,
    FirBannerAdd,
    FirScienceAdd,
    FirPhotoAdd,
    FirRollLB,
    FirRollAdd,
    FirBannerImg
  },
  data()
  {
    return {
      editableTabsValue: '1',
      editableTabs: [{
        title: '首页数据列表',
        name: '1',
        closable: false,
        ref: 'child',
        content: FirInfoLB
      },
      {
        title: '首页视频列表',
        name: '2',
        closable: false,
        content: FirVideoLB
      },
      {
        title: '首页横幅列表',
        name: '3',
        closable: false,
        content: FirBannerLB
      },
      {
        title: '首页图片列表',
        name: '4',
        closable: false,
        content: FirPhotoLB
      },
      {
        title: '科学组织数据列表',
        name: '5',
        closable: false,
        content: ScienceDataLB
      },
      {
        title: '首页滚动数据',
        name: '6',
        closable: false,
        content: FirRollLB
      },
      {
        title: '首页Banner图片',
        name: '7',
        closable: false,
        content: FirBannerImg
      }
      ],
      addobj: {
        title: '添加首页横幅',
        name: '8',
        closable: true,
        content: FirBannerAdd
      },
      addobj1: {
        title: '添加科学组织',
        name: '9',
        closable: true,
        content: FirScienceAdd
      },
      addobj2: {
        title: '添加首页图片',
        name: '10',
        closable: true,
        content: FirPhotoAdd
      },
      addobj3: {
        title: '设置滚动数据',
        name: '11',
        closable: true,
        content: FirRollAdd
      },
      addobj4: {
        title: '添加首页Banner图片',
        name: '12',
        closable: true,
        content: FirBannerImgAdd
      }
    }
  },
  computed:
  {
    ...mapState({
      getActiveName: state => state.activeName
    })
  },
  watch:
  {
    getActiveName:
    {
      handler(nval, oval)
      {
        if (nval.activeName)
          this.editableTabsValue = nval.activeName
        else
          this.editableTabsValue = this.editableTabsValue
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    Tabever(activeName, oldActiveName)
    {
      if (activeName === '1')
        this.$store.commit('onIsLb', '1')
      this.$store.commit('onActiveName', activeName)
    },
    //父组件新增添加Tabs
    addTab()
    {
      let that = this
      window.public.addTab(that)
    },
    addTab2()
    {
      this.editableTabs.push(this.addobj1)
      this.editableTabsValue = this.addobj1.name
    },
    addTab3()
    {
      this.editableTabs.push(this.addobj2)
      this.editableTabsValue = this.addobj2.name
    },
    addTab4()
    {
      console.log(this.addobj4)
      this.editableTabs.push(this.addobj4)
      this.editableTabsValue = this.addobj4.name
    },
    //删除添加Tabs
    removeTab(targetName)
    {
      let that = this
      window.public.removeTab(targetName, that)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/backer/project/FirInfo.vue